import React from 'react';
import { Card } from 'react-bootstrap';
const MetriCard = ({ icon, value, label, bgColor, textColor, styles }) => {
  return (
    <Card 
      className={styles.metriCard} 
      style={{
              border:'none', 
              backgroundColor: bgColor, 
              color: textColor, 
              borderRadius:'0.5rem', 
              boxShadow:'rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px'
              }}>
      <Card.Body className={styles.metricBody}>
        {icon && (
          <div className="metricIcon">
            {icon}
          </div>
        )}
        <h1 className={styles.metricNumber}>{value}</h1>
        <p className="metric-label mb-0">{label}</p>
      </Card.Body>
    </Card>
  );
};

export default MetriCard;
